import { CommonModule } from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    Input,
    NgModule,
    OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Cms } from '@impact/data';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { GlobalDataService } from '../../core/global-data.service';
import { SettingsService } from '../../core/settings.service';
import { StyleBreakpoints } from '../../models/style-breakpoints';
import { SectionHeaderModule } from '../../section-header/section-header.module';
import { IImageBreakpoints } from '../../utils/responsive-image.component';
import { UtilsModule } from '../../utils/utils.module';

@Component({
    selector: 'app-campaigns-overview-spot',
    templateUrl: './campaigns-overview-spot.component.html',
})
class CampaignsOverviewSpotComponent implements OnInit {
    @Input() data: Cms.CampaignsOverviewSpot;

    campaigns: Cms.GlobalCampaignDto[] = [];

    campaignPage$ = this.settingsService
        .get()
        .pipe<string | undefined>(map((s) => s.globalPages.campaignPage?.url));

    imageBreakpoints: IImageBreakpoints[] = [
        {
            breakpoint: StyleBreakpoints.Xsmall,
            width: 460,
        },
        {
            breakpoint: StyleBreakpoints.Small,
            width: 768,
        },
        {
            breakpoint: StyleBreakpoints.Medium,
            width: 1024,
        },
        {
            breakpoint: StyleBreakpoints.Large,
            height: 400,
            width: 400,
            mode: 'crop',
        },
    ];

    constructor(
        private cdr: ChangeDetectorRef,
        private globalDataService: GlobalDataService,
        private settingsService: SettingsService
    ) {}

    ngOnInit() {
        const {
            vehicleMakeTags = [],
            vehicleModelTags = [],
            vehicleVariants = [],
        } = this.data;

        const vehicledIds = vehicleMakeTags
            .map((item) => item.id)
            .concat(vehicleModelTags.map((item) => item.id))
            .concat(vehicleVariants.map((item) => item.id));

        this.globalDataService.getGlobalCampaigns().subscribe((campaigns) => {
            this.campaigns = campaigns.children.reduce<Cms.GlobalCampaignDto[]>(
                (a, v) => reduceCampaigns(a, v, vehicledIds),
                []
            );

            this.cdr.markForCheck();
        });
    }
}

function reduceCampaigns(
    campaigns: Cms.GlobalCampaignDto[],
    campaign: Cms.GlobalCampaignDto,
    vehicledIds: string[]
) {
    const {
        vehicleMakes = [],
        vehicleModels = [],
        vehicleVariants = [],
    } = campaign;

    const filterVehicleData = vehicledIds.some(
        (id) =>
            vehicleMakes.some((item) => item.id === id) ||
            vehicleModels.some((item) => item.id === id) ||
            vehicleVariants.some((item) => item.id === id)
    );

    if (filterVehicleData) {
        campaigns.push(campaign);
    }

    return campaigns;
}

@NgModule({
    declarations: [CampaignsOverviewSpotComponent],
    imports: [
        CommonModule,
        SectionHeaderModule,
        UtilsModule,
        RouterModule,
        TranslateModule.forChild(),
    ],
})
class VehicleCampaignsOverviewSpotModule {}

export const LazySpotComponent = CampaignsOverviewSpotComponent;
